import { jsx as p, Fragment as de, jsxs as x } from "react/jsx-runtime";
import * as a from "react";
import w, { forwardRef as pe } from "react";
import "react-dom";
function Ke(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Q = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ee;
function Ye() {
  return ee || (ee = 1, function(e) {
    (function() {
      var r = {}.hasOwnProperty;
      function n() {
        for (var t = "", u = 0; u < arguments.length; u++) {
          var s = arguments[u];
          s && (t = i(t, o(s)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return n.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var u = "";
        for (var s in t)
          r.call(t, s) && t[s] && (u = i(u, s));
        return u;
      }
      function i(t, u) {
        return u ? t ? t + " " + u : t + u : t;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(Q)), Q.exports;
}
var He = Ye();
const Ze = /* @__PURE__ */ Ke(He), te = {
  "purpur-field-helper-text": "_purpur-field-helper-text_atw6b_1",
  "purpur-field-helper-text--disabled": "_purpur-field-helper-text--disabled_atw6b_9"
}, re = "purpur-field-helper-text", Xe = ({
  children: e,
  className: r,
  disabled: n,
  id: o,
  ...i
}) => {
  const t = Ze([
    r,
    te[re],
    {
      [te[`${re}--disabled`]]: n
    }
  ]);
  return /* @__PURE__ */ p("span", { id: o, className: t, ...i, children: e });
};
function ne(e, r) {
  if (typeof e == "function")
    return e(r);
  e != null && (e.current = r);
}
function Je(...e) {
  return (r) => {
    let n = !1;
    const o = e.map((i) => {
      const t = ne(i, r);
      return !n && typeof t == "function" && (n = !0), t;
    });
    if (n)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const t = o[i];
          typeof t == "function" ? t() : ne(e[i], null);
        }
      };
  };
}
var fe = a.forwardRef((e, r) => {
  const { children: n, ...o } = e, i = a.Children.toArray(n), t = i.find(et);
  if (t) {
    const u = t.props.children, s = i.map((c) => c === t ? a.Children.count(u) > 1 ? a.Children.only(null) : a.isValidElement(u) ? u.props.children : null : c);
    return /* @__PURE__ */ p(W, { ...o, ref: r, children: a.isValidElement(u) ? a.cloneElement(u, void 0, s) : null });
  }
  return /* @__PURE__ */ p(W, { ...o, ref: r, children: n });
});
fe.displayName = "Slot";
var W = a.forwardRef((e, r) => {
  const { children: n, ...o } = e;
  if (a.isValidElement(n)) {
    const i = rt(n), t = tt(o, n.props);
    return n.type !== a.Fragment && (t.ref = r ? Je(r, i) : i), a.cloneElement(n, t);
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
W.displayName = "SlotClone";
var Qe = ({ children: e }) => /* @__PURE__ */ p(de, { children: e });
function et(e) {
  return a.isValidElement(e) && e.type === Qe;
}
function tt(e, r) {
  const n = { ...r };
  for (const o in r) {
    const i = e[o], t = r[o];
    /^on[A-Z]/.test(o) ? i && t ? n[o] = (...u) => {
      t(...u), i(...u);
    } : i && (n[o] = i) : o === "style" ? n[o] = { ...i, ...t } : o === "className" && (n[o] = [i, t].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function rt(e) {
  var r, n;
  let o = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, i = o && "isReactWarning" in o && o.isReactWarning;
  return i ? e.ref : (o = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, i = o && "isReactWarning" in o && o.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var nt = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ot = nt.reduce((e, r) => {
  const n = a.forwardRef((o, i) => {
    const { asChild: t, ...u } = o, s = t ? fe : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(s, { ...u, ref: i });
  });
  return n.displayName = `Primitive.${r}`, { ...e, [r]: n };
}, {}), it = "Label", me = a.forwardRef((e, r) => /* @__PURE__ */ p(
  ot.label,
  {
    ...e,
    ref: r,
    onMouseDown: (n) => {
      var o;
      n.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
me.displayName = it;
var ut = me;
function at(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var oe = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ie;
function st() {
  return ie || (ie = 1, function(e) {
    (function() {
      var r = {}.hasOwnProperty;
      function n() {
        for (var t = "", u = 0; u < arguments.length; u++) {
          var s = arguments[u];
          s && (t = i(t, o(s)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return n.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var u = "";
        for (var s in t)
          r.call(t, s) && t[s] && (u = i(u, s));
        return u;
      }
      function i(t, u) {
        return u ? t ? t + " " + u : t + u : t;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(oe)), oe.exports;
}
var ct = st();
const lt = /* @__PURE__ */ at(ct), U = {
  "purpur-label": "_purpur-label_1jndl_1",
  "purpur-label--negative": "_purpur-label--negative_1jndl_8",
  "purpur-label--disabled": "_purpur-label--disabled_1jndl_11"
}, q = "purpur-label", dt = ({
  children: e,
  className: r,
  disabled: n,
  negative: o = !1,
  ...i
}) => {
  const t = lt([
    r,
    U[q],
    {
      [U[`${q}--disabled`]]: n,
      [U[`${q}--negative`]]: o
    }
  ]);
  return /* @__PURE__ */ p(ut, { className: t, ...i, children: e });
};
function S(e, r, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return r == null ? void 0 : r(i);
  };
}
function ue(e, r) {
  if (typeof e == "function")
    return e(r);
  e != null && (e.current = r);
}
function he(...e) {
  return (r) => {
    let n = !1;
    const o = e.map((i) => {
      const t = ue(i, r);
      return !n && typeof t == "function" && (n = !0), t;
    });
    if (n)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const t = o[i];
          typeof t == "function" ? t() : ue(e[i], null);
        }
      };
  };
}
function O(...e) {
  return a.useCallback(he(...e), e);
}
function G(e, r = []) {
  let n = [];
  function o(t, u) {
    const s = a.createContext(u), c = n.length;
    n = [...n, u];
    const l = (m) => {
      var b;
      const { scope: h, children: f, ...d } = m, v = ((b = h == null ? void 0 : h[e]) == null ? void 0 : b[c]) || s, g = a.useMemo(() => d, Object.values(d));
      return /* @__PURE__ */ p(v.Provider, { value: g, children: f });
    };
    l.displayName = t + "Provider";
    function _(m, h) {
      var v;
      const f = ((v = h == null ? void 0 : h[e]) == null ? void 0 : v[c]) || s, d = a.useContext(f);
      if (d) return d;
      if (u !== void 0) return u;
      throw new Error(`\`${m}\` must be used within \`${t}\``);
    }
    return [l, _];
  }
  const i = () => {
    const t = n.map((u) => a.createContext(u));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || t;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return i.scopeName = e, [o, pt(i, ...r)];
}
function pt(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const n = () => {
    const o = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(t) {
      const u = o.reduce((s, { useScope: c, scopeName: l }) => {
        const m = c(t)[`__scope${l}`];
        return { ...s, ...m };
      }, {});
      return a.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return n.scopeName = r.scopeName, n;
}
var D = a.forwardRef((e, r) => {
  const { children: n, ...o } = e, i = a.Children.toArray(n), t = i.find(mt);
  if (t) {
    const u = t.props.children, s = i.map((c) => c === t ? a.Children.count(u) > 1 ? a.Children.only(null) : a.isValidElement(u) ? u.props.children : null : c);
    return /* @__PURE__ */ p(z, { ...o, ref: r, children: a.isValidElement(u) ? a.cloneElement(u, void 0, s) : null });
  }
  return /* @__PURE__ */ p(z, { ...o, ref: r, children: n });
});
D.displayName = "Slot";
var z = a.forwardRef((e, r) => {
  const { children: n, ...o } = e;
  if (a.isValidElement(n)) {
    const i = vt(n), t = ht(o, n.props);
    return n.type !== a.Fragment && (t.ref = r ? he(r, i) : i), a.cloneElement(n, t);
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
z.displayName = "SlotClone";
var ft = ({ children: e }) => /* @__PURE__ */ p(de, { children: e });
function mt(e) {
  return a.isValidElement(e) && e.type === ft;
}
function ht(e, r) {
  const n = { ...r };
  for (const o in r) {
    const i = e[o], t = r[o];
    /^on[A-Z]/.test(o) ? i && t ? n[o] = (...s) => {
      t(...s), i(...s);
    } : i && (n[o] = i) : o === "style" ? n[o] = { ...i, ...t } : o === "className" && (n[o] = [i, t].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function vt(e) {
  var o, i;
  let r = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = r && "isReactWarning" in r && r.isReactWarning;
  return n ? e.ref : (r = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = r && "isReactWarning" in r && r.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var _t = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], M = _t.reduce((e, r) => {
  const n = a.forwardRef((o, i) => {
    const { asChild: t, ...u } = o, s = t ? D : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(s, { ...u, ref: i });
  });
  return n.displayName = `Primitive.${r}`, { ...e, [r]: n };
}, {});
function gt(e) {
  const r = e + "CollectionProvider", [n, o] = G(r), [i, t] = n(
    r,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), u = (f) => {
    const { scope: d, children: v } = f, g = w.useRef(null), b = w.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ p(i, { scope: d, itemMap: b, collectionRef: g, children: v });
  };
  u.displayName = r;
  const s = e + "CollectionSlot", c = w.forwardRef(
    (f, d) => {
      const { scope: v, children: g } = f, b = t(s, v), y = O(d, b.collectionRef);
      return /* @__PURE__ */ p(D, { ref: y, children: g });
    }
  );
  c.displayName = s;
  const l = e + "CollectionItemSlot", _ = "data-radix-collection-item", m = w.forwardRef(
    (f, d) => {
      const { scope: v, children: g, ...b } = f, y = w.useRef(null), E = O(d, y), A = t(l, v);
      return w.useEffect(() => (A.itemMap.set(y, { ref: y, ...b }), () => void A.itemMap.delete(y))), /* @__PURE__ */ p(D, { [_]: "", ref: E, children: g });
    }
  );
  m.displayName = l;
  function h(f) {
    const d = t(e + "CollectionConsumer", f);
    return w.useCallback(() => {
      const g = d.collectionRef.current;
      if (!g) return [];
      const b = Array.from(g.querySelectorAll(`[${_}]`));
      return Array.from(d.itemMap.values()).sort(
        (A, P) => b.indexOf(A.ref.current) - b.indexOf(P.ref.current)
      );
    }, [d.collectionRef, d.itemMap]);
  }
  return [
    { Provider: u, Slot: c, ItemSlot: m },
    h,
    o
  ];
}
var k = globalThis != null && globalThis.document ? a.useLayoutEffect : () => {
}, bt = a.useId || (() => {
}), yt = 0;
function Rt(e) {
  const [r, n] = a.useState(bt());
  return k(() => {
    n((o) => o ?? String(yt++));
  }, [e]), r ? `radix-${r}` : "";
}
function Y(e) {
  const r = a.useRef(e);
  return a.useEffect(() => {
    r.current = e;
  }), a.useMemo(() => (...n) => {
    var o;
    return (o = r.current) == null ? void 0 : o.call(r, ...n);
  }, []);
}
function ve({
  prop: e,
  defaultProp: r,
  onChange: n = () => {
  }
}) {
  const [o, i] = St({ defaultProp: r, onChange: n }), t = e !== void 0, u = t ? e : o, s = Y(n), c = a.useCallback(
    (l) => {
      if (t) {
        const m = typeof l == "function" ? l(e) : l;
        m !== e && s(m);
      } else
        i(l);
    },
    [t, e, i, s]
  );
  return [u, c];
}
function St({
  defaultProp: e,
  onChange: r
}) {
  const n = a.useState(e), [o] = n, i = a.useRef(o), t = Y(r);
  return a.useEffect(() => {
    i.current !== o && (t(o), i.current = o);
  }, [o, i, t]), n;
}
var Nt = a.createContext(void 0);
function _e(e) {
  const r = a.useContext(Nt);
  return e || r || "ltr";
}
var B = "rovingFocusGroup.onEntryFocus", wt = { bubbles: !1, cancelable: !0 }, j = "RovingFocusGroup", [K, ge, Ct] = gt(j), [It, be] = G(
  j,
  [Ct]
), [Et, At] = It(j), ye = a.forwardRef(
  (e, r) => /* @__PURE__ */ p(K.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p(K.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p(Ot, { ...e, ref: r }) }) })
);
ye.displayName = j;
var Ot = a.forwardRef((e, r) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: o,
    loop: i = !1,
    dir: t,
    currentTabStopId: u,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: c,
    onEntryFocus: l,
    preventScrollOnEntryFocus: _ = !1,
    ...m
  } = e, h = a.useRef(null), f = O(r, h), d = _e(t), [v = null, g] = ve({
    prop: u,
    defaultProp: s,
    onChange: c
  }), [b, y] = a.useState(!1), E = Y(l), A = ge(n), P = a.useRef(!1), [qe, X] = a.useState(0);
  return a.useEffect(() => {
    const R = h.current;
    if (R)
      return R.addEventListener(B, E), () => R.removeEventListener(B, E);
  }, [E]), /* @__PURE__ */ p(
    Et,
    {
      scope: n,
      orientation: o,
      dir: d,
      loop: i,
      currentTabStopId: v,
      onItemFocus: a.useCallback(
        (R) => g(R),
        [g]
      ),
      onItemShiftTab: a.useCallback(() => y(!0), []),
      onFocusableItemAdd: a.useCallback(
        () => X((R) => R + 1),
        []
      ),
      onFocusableItemRemove: a.useCallback(
        () => X((R) => R - 1),
        []
      ),
      children: /* @__PURE__ */ p(
        M.div,
        {
          tabIndex: b || qe === 0 ? -1 : 0,
          "data-orientation": o,
          ...m,
          ref: f,
          style: { outline: "none", ...e.style },
          onMouseDown: S(e.onMouseDown, () => {
            P.current = !0;
          }),
          onFocus: S(e.onFocus, (R) => {
            const Be = !P.current;
            if (R.target === R.currentTarget && Be && !b) {
              const J = new CustomEvent(B, wt);
              if (R.currentTarget.dispatchEvent(J), !J.defaultPrevented) {
                const L = A().filter((N) => N.focusable), Ve = L.find((N) => N.active), We = L.find((N) => N.id === v), ze = [Ve, We, ...L].filter(
                  Boolean
                ).map((N) => N.ref.current);
                Ne(ze, _);
              }
            }
            P.current = !1;
          }),
          onBlur: S(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), Re = "RovingFocusGroupItem", Se = a.forwardRef(
  (e, r) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: o = !0,
      active: i = !1,
      tabStopId: t,
      ...u
    } = e, s = Rt(), c = t || s, l = At(Re, n), _ = l.currentTabStopId === c, m = ge(n), { onFocusableItemAdd: h, onFocusableItemRemove: f } = l;
    return a.useEffect(() => {
      if (o)
        return h(), () => f();
    }, [o, h, f]), /* @__PURE__ */ p(
      K.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: o,
        active: i,
        children: /* @__PURE__ */ p(
          M.span,
          {
            tabIndex: _ ? 0 : -1,
            "data-orientation": l.orientation,
            ...u,
            ref: r,
            onMouseDown: S(e.onMouseDown, (d) => {
              o ? l.onItemFocus(c) : d.preventDefault();
            }),
            onFocus: S(e.onFocus, () => l.onItemFocus(c)),
            onKeyDown: S(e.onKeyDown, (d) => {
              if (d.key === "Tab" && d.shiftKey) {
                l.onItemShiftTab();
                return;
              }
              if (d.target !== d.currentTarget) return;
              const v = Mt(d, l.orientation, l.dir);
              if (v !== void 0) {
                if (d.metaKey || d.ctrlKey || d.altKey || d.shiftKey) return;
                d.preventDefault();
                let b = m().filter((y) => y.focusable).map((y) => y.ref.current);
                if (v === "last") b.reverse();
                else if (v === "prev" || v === "next") {
                  v === "prev" && b.reverse();
                  const y = b.indexOf(d.currentTarget);
                  b = l.loop ? Tt(b, y + 1) : b.slice(y + 1);
                }
                setTimeout(() => Ne(b));
              }
            })
          }
        )
      }
    );
  }
);
Se.displayName = Re;
var Pt = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function xt(e, r) {
  return r !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Mt(e, r, n) {
  const o = xt(e.key, n);
  if (!(r === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(r === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return Pt[o];
}
function Ne(e, r = !1) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus({ preventScroll: r }), document.activeElement !== n)) return;
}
function Tt(e, r) {
  return e.map((n, o) => e[(r + o) % e.length]);
}
var Ft = ye, $t = Se;
function Dt(e) {
  const [r, n] = a.useState(void 0);
  return k(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const t = i[0];
        let u, s;
        if ("borderBoxSize" in t) {
          const c = t.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          u = l.inlineSize, s = l.blockSize;
        } else
          u = e.offsetWidth, s = e.offsetHeight;
        n({ width: u, height: s });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), r;
}
function kt(e) {
  const r = a.useRef({ value: e, previous: e });
  return a.useMemo(() => (r.current.value !== e && (r.current.previous = r.current.value, r.current.value = e), r.current.previous), [e]);
}
function Gt(e, r) {
  return a.useReducer((n, o) => r[n][o] ?? n, e);
}
var we = (e) => {
  const { present: r, children: n } = e, o = jt(r), i = typeof n == "function" ? n({ present: o.isPresent }) : a.Children.only(n), t = O(o.ref, Lt(i));
  return typeof n == "function" || o.isPresent ? a.cloneElement(i, { ref: t }) : null;
};
we.displayName = "Presence";
function jt(e) {
  const [r, n] = a.useState(), o = a.useRef({}), i = a.useRef(e), t = a.useRef("none"), u = e ? "mounted" : "unmounted", [s, c] = Gt(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return a.useEffect(() => {
    const l = T(o.current);
    t.current = s === "mounted" ? l : "none";
  }, [s]), k(() => {
    const l = o.current, _ = i.current;
    if (_ !== e) {
      const h = t.current, f = T(l);
      e ? c("MOUNT") : f === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(_ && h !== f ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, c]), k(() => {
    if (r) {
      let l;
      const _ = r.ownerDocument.defaultView ?? window, m = (f) => {
        const v = T(o.current).includes(f.animationName);
        if (f.target === r && v && (c("ANIMATION_END"), !i.current)) {
          const g = r.style.animationFillMode;
          r.style.animationFillMode = "forwards", l = _.setTimeout(() => {
            r.style.animationFillMode === "forwards" && (r.style.animationFillMode = g);
          });
        }
      }, h = (f) => {
        f.target === r && (t.current = T(o.current));
      };
      return r.addEventListener("animationstart", h), r.addEventListener("animationcancel", m), r.addEventListener("animationend", m), () => {
        _.clearTimeout(l), r.removeEventListener("animationstart", h), r.removeEventListener("animationcancel", m), r.removeEventListener("animationend", m);
      };
    } else
      c("ANIMATION_END");
  }, [r, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: a.useCallback((l) => {
      l && (o.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function T(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Lt(e) {
  var o, i;
  let r = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = r && "isReactWarning" in r && r.isReactWarning;
  return n ? e.ref : (r = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = r && "isReactWarning" in r && r.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var H = "Radio", [Ut, Ce] = G(H), [qt, Bt] = Ut(H), Ie = a.forwardRef(
  (e, r) => {
    const {
      __scopeRadio: n,
      name: o,
      checked: i = !1,
      required: t,
      disabled: u,
      value: s = "on",
      onCheck: c,
      form: l,
      ..._
    } = e, [m, h] = a.useState(null), f = O(r, (g) => h(g)), d = a.useRef(!1), v = m ? l || !!m.closest("form") : !0;
    return /* @__PURE__ */ x(qt, { scope: n, checked: i, disabled: u, children: [
      /* @__PURE__ */ p(
        M.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": i,
          "data-state": Oe(i),
          "data-disabled": u ? "" : void 0,
          disabled: u,
          value: s,
          ..._,
          ref: f,
          onClick: S(e.onClick, (g) => {
            i || c == null || c(), v && (d.current = g.isPropagationStopped(), d.current || g.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ p(
        Vt,
        {
          control: m,
          bubbles: !d.current,
          name: o,
          value: s,
          checked: i,
          required: t,
          disabled: u,
          form: l,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Ie.displayName = H;
var Ee = "RadioIndicator", Ae = a.forwardRef(
  (e, r) => {
    const { __scopeRadio: n, forceMount: o, ...i } = e, t = Bt(Ee, n);
    return /* @__PURE__ */ p(we, { present: o || t.checked, children: /* @__PURE__ */ p(
      M.span,
      {
        "data-state": Oe(t.checked),
        "data-disabled": t.disabled ? "" : void 0,
        ...i,
        ref: r
      }
    ) });
  }
);
Ae.displayName = Ee;
var Vt = (e) => {
  const { control: r, checked: n, bubbles: o = !0, ...i } = e, t = a.useRef(null), u = kt(n), s = Dt(r);
  return a.useEffect(() => {
    const c = t.current, l = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (u !== n && m) {
      const h = new Event("click", { bubbles: o });
      m.call(c, n), c.dispatchEvent(h);
    }
  }, [u, n, o]), /* @__PURE__ */ p(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: n,
      ...i,
      tabIndex: -1,
      ref: t,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Oe(e) {
  return e ? "checked" : "unchecked";
}
var Wt = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Z = "RadioGroup", [zt, fr] = G(Z, [
  be,
  Ce
]), Pe = be(), xe = Ce(), [Kt, Yt] = zt(Z), Me = a.forwardRef(
  (e, r) => {
    const {
      __scopeRadioGroup: n,
      name: o,
      defaultValue: i,
      value: t,
      required: u = !1,
      disabled: s = !1,
      orientation: c,
      dir: l,
      loop: _ = !0,
      onValueChange: m,
      ...h
    } = e, f = Pe(n), d = _e(l), [v, g] = ve({
      prop: t,
      defaultProp: i,
      onChange: m
    });
    return /* @__PURE__ */ p(
      Kt,
      {
        scope: n,
        name: o,
        required: u,
        disabled: s,
        value: v,
        onValueChange: g,
        children: /* @__PURE__ */ p(
          Ft,
          {
            asChild: !0,
            ...f,
            orientation: c,
            dir: d,
            loop: _,
            children: /* @__PURE__ */ p(
              M.div,
              {
                role: "radiogroup",
                "aria-required": u,
                "aria-orientation": c,
                "data-disabled": s ? "" : void 0,
                dir: d,
                ...h,
                ref: r
              }
            )
          }
        )
      }
    );
  }
);
Me.displayName = Z;
var Te = "RadioGroupItem", Fe = a.forwardRef(
  (e, r) => {
    const { __scopeRadioGroup: n, disabled: o, ...i } = e, t = Yt(Te, n), u = t.disabled || o, s = Pe(n), c = xe(n), l = a.useRef(null), _ = O(r, l), m = t.value === i.value, h = a.useRef(!1);
    return a.useEffect(() => {
      const f = (v) => {
        Wt.includes(v.key) && (h.current = !0);
      }, d = () => h.current = !1;
      return document.addEventListener("keydown", f), document.addEventListener("keyup", d), () => {
        document.removeEventListener("keydown", f), document.removeEventListener("keyup", d);
      };
    }, []), /* @__PURE__ */ p(
      $t,
      {
        asChild: !0,
        ...s,
        focusable: !u,
        active: m,
        children: /* @__PURE__ */ p(
          Ie,
          {
            disabled: u,
            required: t.required,
            checked: m,
            ...c,
            ...i,
            name: t.name,
            ref: _,
            onCheck: () => t.onValueChange(i.value),
            onKeyDown: S((f) => {
              f.key === "Enter" && f.preventDefault();
            }),
            onFocus: S(i.onFocus, () => {
              var f;
              h.current && ((f = l.current) == null || f.click());
            })
          }
        )
      }
    );
  }
);
Fe.displayName = Te;
var Ht = "RadioGroupIndicator", $e = a.forwardRef(
  (e, r) => {
    const { __scopeRadioGroup: n, ...o } = e, i = xe(n);
    return /* @__PURE__ */ p(Ae, { ...i, ...o, ref: r });
  }
);
$e.displayName = Ht;
var Zt = Me, Xt = Fe, Jt = $e;
function Qt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var V = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ae;
function er() {
  return ae || (ae = 1, function(e) {
    (function() {
      var r = {}.hasOwnProperty;
      function n() {
        for (var t = "", u = 0; u < arguments.length; u++) {
          var s = arguments[u];
          s && (t = i(t, o.call(this, s)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return n.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var u = "";
        for (var s in t)
          r.call(t, s) && t[s] && (u = i(u, this && this[s] || s));
        return u;
      }
      function i(t, u) {
        return u ? t ? t + " " + u : t + u : t;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(V)), V.exports;
}
var tr = er();
const De = /* @__PURE__ */ Qt(tr), rr = {
  "purpur-radio-button-group-item": "_purpur-radio-button-group-item_5ncfs_1",
  "purpur-radio-button-group-item__radio": "_purpur-radio-button-group-item__radio_5ncfs_14",
  "purpur-radio-button-group-item__label": "_purpur-radio-button-group-item__label_5ncfs_42",
  "purpur-radio-button-group-item__container": "_purpur-radio-button-group-item__container_5ncfs_45",
  "purpur-radio-button-group-item__item-label-container": "_purpur-radio-button-group-item__item-label-container_5ncfs_53",
  "purpur-radio-button-group-item__item-helper": "_purpur-radio-button-group-item__item-helper_5ncfs_53",
  "purpur-radio-button-group-item__label-container": "_purpur-radio-button-group-item__label-container_5ncfs_56",
  "purpur-radio-button-group-item__indicator": "_purpur-radio-button-group-item__indicator_5ncfs_78"
}, C = De.bind(rr), mr = ["ltr", "rtl"], hr = ["horizontal", "vertical"], I = "purpur-radio-button-group-item", ke = pe(
  ({
    disabled: e,
    id: r,
    value: n,
    label: o,
    "data-testid": i,
    helperText: t,
    ...u
  }, s) => /* @__PURE__ */ x("div", { className: C(`${I}__container`), ...u, children: [
    /* @__PURE__ */ p(
      Xt,
      {
        className: C(I),
        "data-testid": i,
        disabled: e,
        id: r,
        ref: s,
        value: n,
        "aria-labelledby": `${r}-label ${r}-helper-text`,
        children: /* @__PURE__ */ p("span", { className: C(`${I}__radio`), children: /* @__PURE__ */ p(Jt, { className: C(`${I}__indicator`) }) })
      }
    ),
    /* @__PURE__ */ x("span", { className: C(`${I}__label-container`), children: [
      /* @__PURE__ */ p(
        dt,
        {
          htmlFor: r,
          id: `${r}-label`,
          className: C(`${I}__label`),
          disabled: e,
          children: o
        }
      ),
      t && /* @__PURE__ */ p(
        Xe,
        {
          className: C(`${I}__helper`),
          "data-testid": i && `${i}-helper-text`,
          disabled: e,
          id: `${r}-helper-text`,
          children: t
        }
      )
    ] })
  ] }, r)
);
function nr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var se = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ce;
function or() {
  return ce || (ce = 1, function(e) {
    (function() {
      var r = {}.hasOwnProperty;
      function n() {
        for (var t = "", u = 0; u < arguments.length; u++) {
          var s = arguments[u];
          s && (t = i(t, o(s)));
        }
        return t;
      }
      function o(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return n.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var u = "";
        for (var s in t)
          r.call(t, s) && t[s] && (u = i(u, s));
        return u;
      }
      function i(t, u) {
        return u ? t ? t + " " + u : t + u : t;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(se)), se.exports;
}
var ir = or();
const ur = /* @__PURE__ */ nr(ir), F = {
  "purpur-heading": "_purpur-heading_k9fhq_1",
  "purpur-heading--hyphens": "_purpur-heading--hyphens_k9fhq_8",
  "purpur-heading--negative": "_purpur-heading--negative_k9fhq_11",
  "purpur-heading--subsection-100": "_purpur-heading--subsection-100_k9fhq_14",
  "purpur-heading--title-100": "_purpur-heading--title-100_k9fhq_20",
  "purpur-heading--title-200": "_purpur-heading--title-200_k9fhq_26",
  "purpur-heading--title-300": "_purpur-heading--title-300_k9fhq_32",
  "purpur-heading--title-400": "_purpur-heading--title-400_k9fhq_38",
  "purpur-heading--title-500": "_purpur-heading--title-500_k9fhq_44",
  "purpur-heading--title-600": "_purpur-heading--title-600_k9fhq_50",
  "purpur-heading--title-700": "_purpur-heading--title-700_k9fhq_56",
  "purpur-heading--display-25": "_purpur-heading--display-25_k9fhq_62",
  "purpur-heading--display-50": "_purpur-heading--display-50_k9fhq_68",
  "purpur-heading--display-100": "_purpur-heading--display-100_k9fhq_74",
  "purpur-heading--display-200": "_purpur-heading--display-200_k9fhq_80"
}, ar = {
  TITLE100: "title-100"
}, $ = "purpur-heading", Ge = ({
  children: e,
  className: r = "",
  enableHyphenation: n = !1,
  negative: o = !1,
  tag: i,
  variant: t = ar.TITLE100,
  ...u
}) => {
  const s = i, c = ur([
    r,
    F[$],
    F[`${$}--${t}`],
    {
      [F[`${$}--hyphens`]]: n,
      [F[`${$}--negative`]]: o
    }
  ]);
  return /* @__PURE__ */ p(s, { className: c, ...u, children: e });
};
Ge.displayName = "Heading";
const je = {
  "purpur-radio-button-group": "_purpur-radio-button-group_v7z64_1",
  "purpur-radio-button-group__item-container": "_purpur-radio-button-group__item-container_v7z64_10",
  "purpur-radio-button-group__container": "_purpur-radio-button-group__container_v7z64_13"
}, sr = De.bind(je), le = "purpur-radio-button-group", Le = pe(
  ({
    id: e,
    "data-testid": r,
    className: n,
    items: o,
    heading: i,
    loop: t = !0,
    orientation: u = "vertical",
    headingTag: s = "h2",
    children: c,
    ...l
  }, _) => {
    if (!(o != null && o.length) && !c)
      return null;
    const m = () => o == null ? void 0 : o.map((h) => /* @__PURE__ */ p(
      ke,
      {
        disabled: l.disabled,
        ...h
      },
      `radio-item-${h.value}`
    ));
    return /* @__PURE__ */ x("div", { className: sr(n, `${le}__container`), children: [
      i && /* @__PURE__ */ x(
        Ge,
        {
          tag: s,
          "data-testid": r ? `${r}-heading` : void 0,
          id: `${e}-heading`,
          variant: "subsection-100",
          children: [
            l.required && /* @__PURE__ */ p("span", { "aria-hidden": !0, children: "* " }),
            i
          ]
        }
      ),
      /* @__PURE__ */ p(
        Zt,
        {
          ...l,
          "aria-labelledby": i ? `${e}-heading` : void 0,
          className: je[le],
          "data-testid": r,
          loop: t,
          orientation: u,
          ref: _,
          children: o != null && o.length ? m() : c
        }
      )
    ] });
  }
);
Le.displayName = "RadioButtonGroupRoot";
const Ue = ({
  children: e,
  ...r
}) => /* @__PURE__ */ p(Le, { ...r, children: e });
Ue.Item = ke;
Ue.displayName = "RadioButtonGroup";
export {
  mr as RADIO_BUTTON_GROUP_DIRECTION,
  hr as RADIO_BUTTON_GROUP_ORIENTATION,
  Ue as RadioButtonGroup
};
//# sourceMappingURL=radio-button-group.es.js.map
